import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Lock, Zap } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
import { CountdownTimer } from '../ui/CountdownTimer';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex flex-col items-center justify-center py-16 px-4 md:py-24 overflow-hidden" data-id="element-70">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-accent/5 blur-[120px] rounded-full pointer-events-none" data-id="element-71" />

      <div className="container max-w-4xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-6" data-id="element-73">
          <span className="inline-block py-1 px-3 rounded-full bg-bg-card border border-border-color text-accent text-xs font-bold tracking-wider uppercase mb-6" data-id="element-74">
            Para hombres que quieren más
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-extrabold text-text-primary leading-tight mb-6" data-id="element-75">
            El Método{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-text-secondary" data-id="element-76">
              Magnético
            </span>
          </h1>
          <p className="text-lg md:text-xl text-text-secondary max-w-2xl mx-auto leading-relaxed" data-id="element-77">
            Un sistema práctico para hombres: más calma, más presencia y mejor
            conexión…
            <span className="text-text-primary font-medium" data-id="element-78">
              {' '}
              sin fingir, sin rogar y sin volverte alguien que no sos.
            </span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-full max-w-2xl bg-bg-card/50 backdrop-blur-sm border border-border-color rounded-2xl p-6 md:p-8 mb-10" data-id="element-79">
          <ul className="space-y-4 text-left" data-id="element-80">
            {['Comunícate con seguridad (sin ansiedad, sin necesidad, sin quedarte en blanco).', 'Construye presencia masculina con hábitos simples: cuerpo, mente y claridad.', 'Sigue un plan claro: qué hacer, qué evitar y cómo mejorar en 7 días con ejercicios guiados.'].map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-81">
                <CheckCircle2 className="w-5 h-5 text-cta-primary flex-shrink-0 mt-0.5" data-id="element-82" />
                <span className="text-text-normal" data-id="element-83">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="w-full mb-10" data-id="element-84">
          <CountdownTimer data-id="element-85" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="flex flex-col items-center w-full max-w-md" data-id="element-86">
          <p className="text-sm text-text-secondary mb-4 italic" data-id="element-87">
            "Aplicado por hombres que querían resultados sin actuar ni
            perseguir."
          </p>

          <CTAButton onClick={scrollToOffer} fullWidth className="mb-4" data-id="element-88">
            QUIERO EL MÉTODO MAGNÉTICO
          </CTAButton>

          <div className="flex items-center justify-center space-x-4 text-xs text-text-secondary mb-6" data-id="element-89">
            <span className="flex items-center" data-id="element-90">
              <Lock className="w-3 h-3 mr-1" data-id="element-91" /> Pago seguro
            </span>
            <span className="w-1 h-1 bg-border-color rounded-full" data-id="element-92"></span>
            <span className="flex items-center" data-id="element-93">
              <Zap className="w-3 h-3 mr-1" data-id="element-94" /> Acceso inmediato
            </span>
            <span className="w-1 h-1 bg-border-color rounded-full" data-id="element-95"></span>
            <span className="flex items-center" data-id="element-96">
              <ShieldCheck className="w-3 h-3 mr-1" data-id="element-97" /> Garantía 7 días
            </span>
          </div>

          <p className="text-[10px] text-text-secondary/60 max-w-xs text-center border-t border-border-color pt-4" data-id="element-98">
            Nota ética: Esto no enseña manipulación. Enseña presencia,
            comunicación y respeto.
          </p>
        </motion.div>

        {/* Trust Badges */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="flex flex-wrap justify-center gap-4 mt-12 opacity-70 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-99">
          {['Acceso inmediato', 'Pago seguro', 'Garantía 7 días'].map((badge, i) => <div key={i} className="flex items-center space-x-2 bg-bg-card border border-border-color px-3 py-1.5 rounded-full" data-id="element-100">
                <ShieldCheck className="w-4 h-4 text-cta-primary" data-id="element-101" />
                <span className="text-xs font-medium text-text-secondary" data-id="element-102">
                  {badge}
                </span>
              </div>)}
        </motion.div>
      </div>
    </section>;
}